import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { Redirect, Link } from "react-router-dom";
import moment from "moment";
import Switch from "react-switch";
import {
  PAGE10,
  IMAGE_FULL_URL,
  IMAGE_NOPHOTO_URL,
  CLOUDFRONT_URL,
} from "../../../config/config";
import CarLeasingView from "../CarLeasingView";
import CarLeasingViewPercent from "../CarLeasingViewPercent";
import CarLeasingViewPercent2 from "../CarLeasingViewPercent2";
import RenderCarButton from "./RenderCarButton";
import { CarUtil } from "../../../utils/carUtil";
import star from "../../../assets/star.png";
// mport axios from 'axios'

class CarRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnClick: "",
      carSelect: 0,
      car_id: "",
      upload_code: "",
      carcalculate: false,
      carLeasingList: [],
      cars: [],
      car_explain: {},
      page: 0,
      count: 0,
      carLeasingType: "car-leasing",
      carLeasingViewType: "percent", //
      width: 0,
      height: 0,
    };
    this.handleOnClick = this.handleOnClick.bind(this);
    this.toQueryString = this.toQueryString.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  toQueryString(paramsObject) {
    return Object.keys(paramsObject)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`
      )
      .join("&");
  }

  handleOnClick(action, car) {
    let search3 = this.toQueryString(car);
    this.setState({
      btnClick: action,
      carSelect: search3,
      car_id: car.car_id,
      upload_code: car.car_upload_code,
    });

    if (action === "car-edit-status") {
      this.props.onCarStatusEdit(car);
    } else if (action === "car-calculate") {
      this.props.onCarCalculate(car);
    } else if (action === "car-share") {
      //alert(car.car_share)
      this.props.onCarShare(car);
    } else if (action === "car-delete") {
      this.props.onCarDelete(car);
    } else if (action === "car-leasing") {
      this.props.onCarLeasing(car);
    } else if (action === "car-leasing2") {
      this.props.onCarLeasing2(car);
    }
  }

  componentDidMount() {
    this.setState({
      cars: this.props.cars,
      page: this.props.page,
      count: this.props.count,
    });

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.carLeasingList.length === 0 &&
      this.props.carLeasingList.length === 0
    ) {
      this.setState({ carLeasingList: [] });
    } else if (nextProps.carLeasingList !== this.props.carLeasingList) {
      // && this.props.carLeasingList.length === 0
      if (nextProps.carLeasingList.length > 0) {
        this.setState({
          carLeasingList: nextProps.carLeasingList,
        });
      } else {
        this.setState({ carLeasingList: [] });
      }
    }

    if (nextProps.cars !== this.props.cars) {
      this.setState({
        cars: nextProps.cars,
        page: nextProps.page,
        count: nextProps.count,
      });
    }
  }

  /* shouldComponentUpdate(nextProps, nextState) {
    console.log('shouldComponentUpdate CarRow')
    console.log(nextProps.carLeasingList)
    return this.props.carLeasingList !== nextProps.carLeasingList || nextState.input !== this.state.input
  } */

  render() {
    // console.log(this.state.btnClick)
    const { user_type } = this.props;

    let target = "";
    if (this.state.btnClick === "car-repair") {
      target = "/car-repair/new?car_id=" + this.state.car_id;
      return <Redirect push to={target} />;
    } else if (this.state.btnClick === "car-detail") {
      target = "/cars/detail/?car_id=" + this.state.car_id;
      target += "&upload_code=" + this.state.upload_code;
      // push
      return <Redirect to={target} target={"_blank"} />;
    } else if (this.state.btnClick === "car-buy") {
      target = "/sales/buy/?car_id=" + this.state.car_id;
      return <Redirect push to={target} />;
    } else if (this.state.btnClick === "car-book") {
      target = "/cars/book/?car_id=" + this.state.car_id;
      return <Redirect push to={target} />;
    } else if (this.state.btnClick === "car-book-cancel") {
      target = "/cars/book-cancel/?car_id=" + this.state.car_id;
      return <Redirect push to={target} />;
    } else if (this.state.btnClick === "car-check") {
      // console.log(this.state.btnClick)
      target = "/car-check/?car_id=" + this.state.car_id;
      return <Redirect push to={target} />;
    }

    let car_all = this.state.count;
    let page = this.state.page;
    let start_row = 0;
    if (car_all > 0 && page > 0) {
      start_row = Number(page - 1) * PAGE10;
      // 1 x 10 = 10
      // 2 x 10 = 20
      // 3 x 10 = 30
      // console.log('car_all='+car_all)
      // console.log('page='+page)
    }

    let tbodyList = this.state.cars.map((car, index) => {
      let order = Number(car_all - start_row) - index; // 16 <br/> #{car.car_id}
      // TODx: จำนวนวันรถจอด
      let day_stay = "-";
      let car_date_in = moment(car.car_date_in);
      let current_date = moment(new Date());
      day_stay = current_date.diff(car_date_in, "days");

      let car_date_register =
        "วันที่จดทะเบียน: " +
        (car.car_date_regis != null && car.car_date_regis !== "0000-00-00"
          ? moment(car.car_date_regis).locale("th").format("LL")
          : "-");

      let image_url = "";
      if (car.car_upload_filename !== null) {
        if (car.car_upload_filename.includes("https")) {
          // let car_upload_key = car.car_upload_key
          image_url = CLOUDFRONT_URL + car.car_upload_key;
          // image_url = car.car_upload_filename
        } else {
          image_url = IMAGE_FULL_URL + car.car_upload_filename;
        }
      } else {
        image_url = IMAGE_NOPHOTO_URL;
      }

      let width = this.state.width;

      let imgWidth = "";
      if (width >= 1340) {
        imgWidth = "320px";
      } else if (width >= 1024) {
        imgWidth = "180px";
      } else if (width >= 980) {
        imgWidth = "160px";
      } else {
        imgWidth = "140px";
      }

      let car_sale_price = Number(car.car_sale_price);
      let base = (car_sale_price * 2000) / 100000;
      let installation5 = base + 1000;
      let installation6 = base;
      let installation7 = base - 700;

      if (car_sale_price === 0) {
        installation5 = 0;
        installation6 = 0;
        installation7 = 0;
      }

      if (user_type === "technician") {
        return (
          <tr className="text-center" key={index}>
            <td>{order}</td>
            <td>
              <div className="row">
                <div className="col-md-12 mt-2">
                  {/*<Link to={'/cars/albums/?car_id=' + car.car_id + '&upload_code=' + car.car_upload_code}
                         target='_blank'
                   >
                         <img src={image_url}
                              style={{ 'cursor': 'pointer', 'width': imgWidth, 'height': 'auto' }}
                              alt="car"/>
                   </Link>*/}
                  <a
                    href={
                      "/cars/albums/?car_id=" +
                      car.car_id +
                      "&upload_code=" +
                      car.car_upload_code
                    }
                    target="_blank"
                  >
                    <img
                      src={image_url}
                      style={{
                        cursor: "pointer",
                        width: imgWidth,
                        height: "auto",
                      }}
                      alt="car"
                    />
                  </a>
                </div>
              </div>
            </td>
            <td className="text-center">
              <strong>
                {car.car_name}
                &nbsp;&nbsp;
                <span
                  className="badge"
                  style={{ backgroundColor: car.car_status_color }}
                >
                  {car.car_status_name}
                </span>
              </strong>
              <br />
              {/*<strong> ทะเบียนรถ : {car.car_license_plate_new}</strong> */}
              {car.car_license_plate_new === "" ? null : (
                <>
                  <strong> ทะเบียนรถ : {car.car_license_plate_new}</strong>
                  &nbsp; <strong>จ.{car.province_name_new}</strong>
                </>
              )}
              {car.car_license_plate_new !== "" &&
              car.car_license_plate_old !== "" &&
              car.car_license_plate_new !== car.car_license_plate_old ? (
                <br />
              ) : null}
              {car.car_license_plate_new !== car.car_license_plate_old &&
              car.car_license_plate_old !== "" ? (
                <>
                  <strong>
                    {" "}
                    &nbsp;&nbsp; ทะเบียนเดิม : {car.car_license_plate_old}{" "}
                    &nbsp;จ.{car.province_name_old}
                  </strong>
                </>
              ) : null}
              {car.car_share === "show" ? (
                <div>
                  <br />
                  <img
                    src={"img/if_world.png"}
                    style={{ width: 16 }}
                    className={car.car_share === "show" ? "" : "hidden"}
                    alt="share status"
                  />
                </div>
              ) : null}
              <br />
              <strong>{car_date_register} </strong>
              &nbsp;&nbsp;
              <span
                className="badge mt-1"
                style={{ backgroundColor: "#78c05d" }}
              >
                รถจอด : {car.park_location}
              </span>
              <br />
              {this.props.branch.length > 1 ? (
                <>
                  <span
                    className="badge mt-1"
                    style={{ backgroundColor: "#eeb877" }}
                  >
                    สาขา : {car.branch_name}
                  </span>
                  <br />
                </>
              ) : null}
              สถานะเล่ม:{" "}
              {CarUtil.convertLicenseIdToName(car.liciense_status_id)}
            </td>
            <td>
              <button
                onClick={() => this.handleOnClick("car-check", car)}
                type="button"
                className={"btn btn-primary btn-sm btn-block"}
              >
                <i className="icon-check">&nbsp;ประเมินซ่อมสี</i>
              </button>

              <button
                onClick={() => this.handleOnClick("car-repair", car)}
                type="button"
                className="btn btn-danger btn-sm btn-block"
              >
                <i className="icon-wrench">&nbsp;ซ่อม/ปรับแต่ง</i>
              </button>
            </td>
          </tr>
        );
      } else {
        return (
          <tr className="text-center" key={index}>
            <td>{order}</td>
            <td>
              <div className="row">
                <div className="col-md-12 mt-2">
                  {/*<img src={image_url}
                       style={{ 'cursor': 'pointer', 'width': imgWidth, 'height': 'auto' }}
                       alt="car"/>*/}

                  <Link
                    to={
                      "/cars/albums/?car_id=" +
                      car.car_id +
                      "&upload_code=" +
                      car.car_upload_code
                    }
                    target="_blank"
                  >
                    <img
                      src={image_url}
                      style={{
                        cursor: "pointer",
                        width: imgWidth,
                        height: "auto",
                      }}
                      alt="car"
                    />
                  </Link>
                </div>
              </div>
              <div className="row hidden-md">
                <div className="col col-sm-12 col-md-12 col-lg-12 mt-2">
                  <button
                    type="button"
                    onClick={() => this.handleOnClick("car-calculate", car)}
                    className="btn btn-success btn-sm btn-block "
                  >
                    <i className="icon-calculator"></i> ค่างวด
                  </button>
                </div>
                <div className="col col-sm-12 col-md-12 col-lg-12 mt-2">
                  <button
                    type="button"
                    onClick={() => this.handleOnClick("car-share", car)}
                    className="btn btn-primary btn-sm btn-block "
                  >
                    <i className="icon-share"></i> แชร์
                  </button>
                </div>
              </div>

              <div
                className={
                  this.props.user_type === "freelance"
                    ? "hidden"
                    : "row  text-center pt-2"
                }
              >
                <div className="form-group col-6">
                  {/*<label htmlFor="liciense_status_id">สถานะเล่ม</label>*/}
                  <select
                    className="form-control"
                    id="liciense_status_id"
                    name="liciense_status_id"
                    value={car.liciense_status_id}
                    onChange={(e) =>
                      this.props.onCarLicienseStatusIdChange(e, car.car_id)
                    }
                  >
                    <option value="0">--สถานะเล่ม--</option>
                    <option value="1">มีเล่ม</option>
                    {/*<option value="2">ยังไม่ปิดบัญชี</option>
                  <option value="3">รอเล่มปิดบัญชี</option>
                  <option value="4">มีเล่มอยู่เต็นท์</option>*/}
                    <option value="5">ไม่มีเล่ม</option>
                  </select>
                </div>

                <div className="form-group col-6">
                  {/*<label htmlFor="person_vat_id">สถานะเล่ม</label>*/}
                  <select
                    className="form-control"
                    id="person_vat_id"
                    name="person_vat_id"
                    value={car.person_vat_id}
                    onChange={(e) =>
                      this.props.onCarPersonVatIdChange(e, car.car_id)
                    }
                  >
                    {/* <option value="0">--บุคคล/vat--</option>
                    <option value="1">บุคคล</option>
                    <option value="2">vat</option> */}
                    {CarUtil.getPersonVatOptions().map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div
                className={
                  this.props.user_type === "freelance" ? "hidden" : "row"
                }
              >
                <div className="col col-sm-12 col-md-12 col-lg-12 mt-2 ">
                  <textarea
                    id="car_explain"
                    name="car_explain"
                    rows={3}
                    value={car.car_explain}
                    onChange={(e) =>
                      this.props.onCarExplainFormEdit(e, car.car_id)
                    }
                    placeholder="หมายเหตุ"
                  ></textarea>
                  <br />
                  <button
                    className={
                      car.car_edit ? "btn btn-sm btn-primary " : "hidden"
                    }
                    onClick={() =>
                      this.props.onCarExplainUpdate(car.car_id, car.car_explain)
                    }
                  >
                    บันทึก
                  </button>
                  <div className={car.car_save ? "fadeOut" : "hidden"}>
                    <span className="text-success"> บันทึกเรียบแล้วแล้ว </span>
                  </div>
                </div>
              </div>
              {/*
              <div className="row">
                <div className="col col-sm-12 col-md-12 col-lg-12 mt-2 ">
                <strong>วันที่ซื้อรถเข้ามา: {moment(car.car_date_in).format('DD-MM-YYYY')}</strong> <br/>
                <strong>แก้ไขล่าสุด: {moment(car.updated_at).format('DD-MM-YYYY HH:mm:ss')}</strong> <br/>
                </div>
              </div>
            */}
              <div
                className={
                  this.props.user_type === "subsale" ||
                  this.props.user_type === "freelance"
                    ? "hidden"
                    : "row"
                }
              >
                <div className="col col-sm-12 col-md-12 col-lg-12 mt-2 ">
                  <strong>
                    ซื้อเข้า {moment(car.car_date_in).format("DD-MM-YYYY")}
                    <br />
                    (จอด {day_stay} วัน) &nbsp;
                    {day_stay > 90 ? (
                      <span
                        className="badge blink"
                        style={{ backgroundColor: "#f86c6b" }}
                      >
                        {/*<Blink color='white' text='จอดเกิน 3 เดือน' fontSize={14} fontStyle="normal">

                          </Blink>*/}
                        จอดเกิน 3 เดือน
                      </span>
                    ) : null}
                  </strong>
                  <div className="col col-sm-12 col-md-12 col-lg-12 mt-2 text-danger">
                    <strong>
                      {" "}
                      ป้ายแดง: {car.plate_red === "" ? "-" : car.plate_red}{" "}
                    </strong>
                  </div>
                  <br />
                  <strong>
                    แก้ไขล่าสุด:{" "}
                    {moment(car.updated_at).format("DD-MM-YYYY HH:mm:ss")}
                  </strong>{" "}
                  <br />
                </div>
              </div>
            </td>
            <td className="text-center">
              {car.is_star === 1 && (
                <img src={star} style={styles.star} alt="star" />
              )}
              <strong>
                {car.car_name}
                &nbsp;&nbsp;
                <span
                  className="badge"
                  style={{ backgroundColor: car.car_status_color }}
                >
                  {car.car_status_name}
                </span>
              </strong>
              <br />
              {/*<strong> ทะเบียนรถ : {car.car_license_plate_new}</strong> */}
              {car.car_license_plate_new === "" ? null : (
                <>
                  <strong> ทะเบียนรถ : {car.car_license_plate_new}</strong>
                  &nbsp; <strong>จ.{car.province_name_new}</strong>
                </>
              )}
              {car.car_license_plate_new !== "" &&
              car.car_license_plate_old !== "" &&
              car.car_license_plate_new !== car.car_license_plate_old ? (
                <br />
              ) : null}
              {car.car_license_plate_new !== car.car_license_plate_old &&
              car.car_license_plate_old !== "" ? (
                <>
                  <strong>
                    {" "}
                    &nbsp;&nbsp; ทะเบียนเดิม : {car.car_license_plate_old}{" "}
                    &nbsp;จ.{car.province_name_old}
                  </strong>
                </>
              ) : null}
              {car.car_share === "show" ? (
                <div>
                  <br />
                  <img
                    src={"img/if_world.png"}
                    style={{ width: 16 }}
                    className={car.car_share === "show" ? "" : "hidden"}
                    alt="share status"
                  />
                </div>
              ) : null}
              <br />
              <strong>{car_date_register} </strong>
              &nbsp;&nbsp;
              <span
                className="badge mt-1"
                style={{ backgroundColor: "#78c05d" }}
              >
                รถจอด : {car.park_location}
              </span>
              <br />
              {this.props.branch.length > 1 ? (
                <>
                  <span
                    className="badge mt-1"
                    style={{ backgroundColor: "#eeb877" }}
                  >
                    สาขา : {car.branch_name}
                  </span>
                  <br />
                </>
              ) : null}
              สถานะเล่ม:{" "}
              {CarUtil.convertLicenseIdToName(car.liciense_status_id)}
              <img
                src={"img/if_world.png"}
                style={{ width: 16 }}
                className={car.car_share === "show" ? "" : "hidden"}
                alt="share status"
              />
              {(this.props.user_type === "admin" ||
                this.props.user_type === "freelance") && (
                <>
                  <br />
                  <div className="d-flex mt-1 justify-content-center pt-1 ">
                    <span
                      className="badge"
                      style={{
                        backgroundColor:
                          car.is_star === 1 ? "#FFCC00" : "#808080",
                      }}
                    >
                      {car.is_star === 1 ? "ติดดาว" : "ไม่ติดดาว"}
                    </span>
                    &nbsp;
                    {this.props.user_type === "admin" && (
                      <Switch
                        height={24}
                        width={64}
                        onChange={(checked) => {
                          // this.onChangeSwitchIsBank(checked, item)
                          if (this.props.user_type === "freelance") {
                            return false;
                          }
                          this.props.onCarStarChange(checked, car.car_id);
                        }}
                        checked={car.is_star === 1}
                      />
                    )}
                  </div>
                </>
              )}
              <br />
              <center>
                {/*<CarLeasingView
              car={car}
              carLeasingList={this.state.carLeasingList.length !== 0 && this.state.carLeasingList[0].car_id===car.car_id ? this.state.carLeasingList : []} />*/}

                {this.props.user_type === "freelance" ? (
                  <>
                    <table>
                      <thead>
                        <tr>
                          <td
                            colSpan={3}
                            className="text-center font-weight-bold"
                          >
                            ค่างวด
                          </td>
                        </tr>
                        <tr>
                          <td className="text-center font-weight-bold">5 ปี</td>
                          <td className="text-center font-weight-bold">6 ปี</td>
                          <td className="text-center font-weight-bold">7 ปี</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center font-weight-bold">
                            {installation5}
                          </td>
                          <td className="text-center font-weight-bold">
                            {installation6}
                          </td>
                          <td className="text-center font-weight-bold">
                            {installation7}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                ) : this.state.carLeasingViewType === "percent" ? (
                  this.props.user_type !== "subsale" ? (
                    <CarLeasingViewPercent
                      car={car}
                      carLeasingList={this.state.carLeasingList}
                    />
                  ) : (
                    <CarLeasingViewPercent2
                      car={car}
                      carLeasingList={this.state.carLeasingList}
                    />
                  )
                ) : (
                  <CarLeasingView
                    car={car}
                    carLeasingList={this.state.carLeasingList}
                  />
                )}

                {/*<>
                  <div>
                    {this.state.carLeasingType}
                  </div>
                  <button type="button"
                          style={{marginTop: 8}}
                          onClick={() => this.handleOnClick('car-leasing2', car)}
                          className="btn btn-outline-danger btn-sm btn-block w-50">
                    <i className="icon-diamond"></i> ยอดจัดตามเปอร์เซ็นต์
                  </button>
                </>*/}

                {this.props.user_type === "subsale" ||
                this.props.user_type === "freelance" ? null : (
                  <button
                    type="button"
                    style={{ marginTop: 8 }}
                    onClick={() => this.handleOnClick("car-leasing", car)}
                    className="btn btn-outline-danger btn-sm btn-block w-50"
                  >
                    <i className="icon-diamond"></i> ยอดจัด
                  </button>
                )}
              </center>
            </td>
            {/*<td className={this.props.user_type === 'admin' ? 'text-center' : 'hidden'}>
            <NumberFormat
            value={car.car_cost} displayType={'text'} thousandSeparator={true} prefix={'฿'}/>
          </td>*/}
            <td
              className={this.props.user_type === "technician" ? "hidden" : ""}
            >
              <table className="table2">
                <tbody>
                  <tr
                    className={
                      this.props.user_type === "admin"
                        ? "text-primary"
                        : "hidden"
                    }
                  >
                    <td className="text-right">ทุนซื้อเข้า:</td>
                    <td className="text-right">
                      <NumberFormat
                        value={car.car_cost}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"฿"}
                      />
                    </td>
                  </tr>
                  <tr
                    className={
                      this.props.user_type === "admin"
                        ? "text-primary"
                        : "hidden"
                    }
                  >
                    <td className="text-right">ทุนซ่อม/แต่ง:</td>
                    <td className="text-right">
                      <NumberFormat
                        value={car.car_cost_repair}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"฿"}
                      />
                    </td>
                  </tr>
                  <tr
                    className={
                      this.props.user_type === "admin"
                        ? "text-primary"
                        : "hidden"
                    }
                  >
                    <td className="text-right">ทุนอื่นๆ:</td>
                    <td className="text-right">
                      <NumberFormat
                        value={car.car_cost_other}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"฿"}
                      />
                    </td>
                  </tr>
                  <tr
                    className={
                      this.props.user_type === "admin"
                        ? "text-primary"
                        : "hidden"
                    }
                  >
                    <td className="text-right">ค่าภาษีรถยนต์:</td>
                    <td className="text-right">
                      <NumberFormat
                        value={car.car_cost_tax}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"฿"}
                      />
                    </td>
                  </tr>
                  <tr
                    className={
                      this.props.user_type === "admin"
                        ? "text-primary"
                        : "hidden"
                    }
                  >
                    <td className="text-right">รายการเก็บสี:</td>
                    <td className="text-right">
                      <NumberFormat
                        value={car.car_cost_act}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"฿"}
                      />
                    </td>
                  </tr>
                  <tr
                    className={
                      this.props.user_type === "admin"
                        ? "text-primary"
                        : "hidden"
                    }
                  >
                    <td className="text-right">ค่าคอมมิชชั่น:</td>
                    <td className="text-right">
                      <NumberFormat
                        value={car.car_cost_commissions}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"฿"}
                      />
                    </td>
                  </tr>
                  <tr
                    className={
                      this.props.user_type === "admin"
                        ? "text-primary"
                        : "hidden"
                    }
                  >
                    <td className="text-right">ค่าใช้จ่ายอื่นๆ:</td>
                    <td className="text-right">
                      <NumberFormat
                        value={car.car_cost_expenses_other}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"฿"}
                      />
                    </td>
                  </tr>

                  <tr
                    className={
                      this.props.user_type === "admin"
                        ? "text-primary"
                        : "hidden"
                    }
                  >
                    <td className="text-right">รวมทุน:</td>
                    <td className="text-right">
                      <NumberFormat
                        value={
                          (car.car_cost || 0) +
                          (car.car_cost_repair || 0) +
                          (car.car_cost_other || 0) +
                          (car.car_cost_tax || 0) +
                          (car.car_cost_act || 0) +
                          (car.car_cost_commissions || 0) +
                          (car.car_cost_expenses_other || 0)
                        }
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"฿"}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className="text-right">ราคาขาย:</td>
                    <td className="text-right">
                      <NumberFormat
                        value={car.car_sale_price}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"฿"}
                      />
                    </td>
                  </tr>

                  <tr
                    className={
                      this.props.user_type === "admin"
                        ? "text-success"
                        : "hidden"
                    }
                  >
                    <td className="text-right">กำไร:</td>
                    <td className="text-right">
                      <NumberFormat
                        value={
                          (car.car_sale_price || 0) -
                          (
                            (car.car_cost || 0) +
                            (car.car_cost_repair || 0) +
                            (car.car_cost_other || 0) +
                            (car.car_cost_tax || 0) +
                            (car.car_cost_act || 0) +
                            (car.car_cost_commissions || 0) +
                            (car.car_cost_expenses_other || 0)
                          )
                        }
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"฿"}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td
              className={
                this.props.user_type === "freelance" ? "hidden" : "text-primary"
              }
            >
              {this.props.user_type === "freelance" ? null : (
                <>
                  <Link
                    to={
                      "/cars/detail/?car_id=" +
                      car.car_id +
                      "&upload_code=" +
                      car.car_upload_code
                    }
                    target="_blank"
                    type="button"
                    className="btn btn-info btn-sm btn-block"
                  >
                    <i className="icon-list">&nbsp;รายละเอียดรถ</i>
                  </Link>
                  <button
                    onClick={() => this.handleOnClick("car-repair", car)}
                    type="button"
                    className="btn btn-danger btn-sm btn-block"
                  >
                    <i className="icon-wrench">&nbsp;ซ่อม/ปรับแต่ง</i>
                  </button>
                  <button
                    onClick={() => this.handleOnClick("car-edit-status", car)}
                    type="button"
                    className={
                      this.props.user_type === "technician"
                        ? "hidden"
                        : "btn btn-warning btn-sm btn-block"
                    }
                  >
                    <i className="icon-note">&nbsp;แก้ไขสถานะ</i>
                  </button>
                </>
              )}

              <RenderCarButton
                car={car}
                buttonType="car-book"
                carLeasingList={this.state.carLeasingList}
                user_type={this.props.user_type}
                handleOnClick={this.handleOnClick}
              />

              {this.props.user_type === "subsale" ||
              this.props.user_type === "freelance" ? null : (
                <RenderCarButton
                  car={car}
                  buttonType="car-buy"
                  carLeasingList={this.state.carLeasingList}
                  user_type={this.props.user_type}
                  handleOnClick={this.handleOnClick}
                />
              )}

              <button
                onClick={() => this.handleOnClick("car-delete", car)}
                type="button"
                className={
                  this.props.user_type === "admin"
                    ? "btn btn-danger btn-sm btn-block"
                    : "hidden"
                }
              >
                <i className="icon-trash">&nbsp;ลบรถคันนี้</i>
              </button>
            </td>
          </tr>
        );
      }
    });

    let tbEmpty = (
      <tr>
        <td colSpan={6} className="text-danger text-center">
          ไม่พบข้อมูลรถ
        </td>
      </tr>
    );

    let tbBody = this.state.cars.length === 0 ? tbEmpty : tbodyList;

    return <tbody>{tbBody}</tbody>;
  }
}

const styles = {
  // fadeOut: {
  //   color: '#FFFFFF',
  //   textAlign: 'center',
  //   webkitTransition: 'opacity 3s ease-in-out',
  //   opacity: 1
  // },
  star: {
    width: 42,
    marginRight: 4,
  },
};

export default CarRow;
